import { useState } from 'react';

const DOC_TYPES = [
    { value: 'ID_CARD', label: 'کارت ملی', icon: '🪪' },
    { value: 'PHOTO',   label: 'تصویر پرسنلی', icon: '📷' },
    { value: 'OTHER',   label: 'سایر مدارک', icon: '📄' },
];

export default function Step5_Documents({ data, onChange, onNext, onBack }) {
    const [type, setType] = useState('ID_CARD');
    const [label, setLabel] = useState('');
    const [file, setFile] = useState(null);
    const [error, setError] = useState('');

    const docs = data.documents || [];
    const setDocs = (list) => onChange({ ...data, documents: list });

    const addDoc = () => {
        if (!file) { setError('لطفاً یک فایل انتخاب کنید'); return; }
        setDocs([...docs, { type, label: label || DOC_TYPES.find(d => d.value === type)?.label, file }]);
        setFile(null);
        setLabel('');
        setError('');
        // reset file input
        const input = document.getElementById('aaw-file-input');
        if (input) input.value = '';
    };

    const removeDoc = (i) => setDocs(docs.filter((_, idx) => idx !== i));

    const validate = () => {
        if (docs.length === 0) { setError('حداقل یک مدرک (کارت ملی) بارگذاری کنید'); return false; }
        return true;
    };

    return (
        <div>
            <h2 className="aaw-step-title">بارگذاری مدارک</h2>
            <p className="aaw-step-desc">مدارک هویتی خود را بارگذاری کنید. حداقل کارت ملی الزامی است.</p>

            {/* existing docs */}
            {docs.length > 0 && (
                <div className="aaw-doc-list">
                    {docs.map((doc, i) => {
                        const meta = DOC_TYPES.find(d => d.value === doc.type);
                        return (
                            <div key={i} className="aaw-doc-item">
                                <span className="aaw-doc-icon">{meta?.icon}</span>
                                <div className="aaw-doc-info">
                                    <strong>{doc.label}</strong>
                                    <span>{doc.file?.name}</span>
                                </div>
                                <button className="aaw-doc-remove" onClick={() => removeDoc(i)}>✕</button>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* add new doc */}
            <div className="aaw-doc-add-row">
                <div className="aaw-field" style={{ marginBottom: 0 }}>
                    <label className="aaw-label">نوع مدرک</label>
                    <select className="aaw-select" value={type} onChange={e => setType(e.target.value)}>
                        {DOC_TYPES.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                    </select>
                </div>
                <div className="aaw-field" style={{ marginBottom: 0 }}>
                    <label className="aaw-label">عنوان (اختیاری)</label>
                    <input
                        className="aaw-input"
                        value={label}
                        onChange={e => setLabel(e.target.value)}
                        placeholder="مثال: کارت ملی جلو"
                    />
                </div>
                <div className="aaw-field" style={{ marginBottom: 0, gridColumn: '1 / -1' }}>
                    <label className="aaw-file-label" htmlFor="aaw-file-input">
                        📎 {file ? file.name : 'انتخاب فایل (PDF / تصویر)'}
                    </label>
                    <input
                        id="aaw-file-input"
                        className="aaw-file-input"
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={e => setFile(e.target.files[0] || null)}
                    />
                </div>
            </div>

            <button
                type="button"
                className="aaw-btn aaw-btn-secondary"
                style={{ marginBottom: 8 }}
                onClick={addDoc}
            >
                + افزودن مدرک
            </button>

            {error && <p className="aaw-error">{error}</p>}

            <div className="aaw-nav">
                <button className="aaw-btn aaw-btn-secondary" onClick={onBack}>→ مرحله قبل</button>
                <button
                    className="aaw-btn aaw-btn-primary"
                    onClick={() => { if (validate()) onNext(); }}
                >
                    مرحله بعد ←
                </button>
            </div>
        </div>
    );
}
